import { render, staticRenderFns } from "./ProductIntroRas.vue?vue&type=template&id=138301f8&scoped=true&"
import script from "./ProductIntroRas.vue?vue&type=script&lang=js&"
export * from "./ProductIntroRas.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntroRas.vue?vue&type=style&index=0&id=138301f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138301f8",
  null
  
)

export default component.exports